import { pilot } from '~/services/serviceInstances';

interface Response {
  client: any;
}

export const getExistingClientBySubdomain = async ({
  subdomain,
}: {
  subdomain: string;
}) => {
  const response: Response = await pilot.get(`client/${subdomain}/`);

  return {
    client: response.client,
  };
};
